<template>
  <div class="breadcrumbs">
    <span v-for="(breadcrumb, index) in breadcrumbsList" :key="index">
      <span v-if="breadcrumb.linkTo">
        <router-link
          :to="{ name: breadcrumb.linkTo, params: { ...$route.params } }"
          class="text-link breadcrumbs__link">
          {{ breadcrumb.linkText }}
        </router-link>
      </span>
      <span v-else>{{ breadcrumb.linkText }}</span>
      <span v-if="index !== (breadcrumbsList.length - 1)">/ </span>
    </span>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { get, find } from 'lodash-es'

  export default {
    name: 'Breadcrumbs',

    computed: {
      breadcrumbsList() {
        return this.$route.matched
          .filter(route => route.meta.breadcrumb)
          .map(route => {
            const breadcrumb = route.meta.breadcrumb
            if (breadcrumb.storePath) {
              const id = this.$route.params[route.meta.paramName]
              const storedRoute = find(get(this.storedRoutes, breadcrumb.storePath), { id })
              return storedRoute
            }

            return breadcrumb
          })
      },

      ...mapState({ storedRoutes: state => state.routes.routes })
    }
  }
</script>

<style lang="scss" scoped>
  .breadcrumbs {
    font-size: $font-size-sm;
    line-height: $line-height-md;
    color: $muted-color;
  }

  .breadcrumbs__link.router-link-exact-active {
    pointer-events: none;
  }
</style>
